module.exports = __webpack_public_path__ + "img/iphone-pro-max.78fb511.webp";